export default {"src":"/gb/en/_next/static/media/BBA_Winner_Best_British_bank.bfe7a033.svg","height":64,"width":235,"blurWidth":0,"blurHeight":0};